import {
  REACT_APP_APPLICATION_CODE,
  REACT_APP_API_BASE_URL_LOGIN,
  UPDATE_SUCCESS_MESSAGE,
} from "constants/index";

import { Dispatch, SetStateAction } from "react";

import { useChangePassword, useGetOTP } from "features/auth/components/query";
import { useNotification } from "hooks/useNotification";
import { useUser } from "libs/auth";
import { UseFormReset } from "react-hook-form";

import { ResetPasswordForm } from "./ResetPasswordForm";

export const ResetPassword = () => {
  const { data: user, isSuccess: isSuccessUser } = useUser();

  const { mutate, isSuccess, error } = useGetOTP({
    axios: { baseURL: REACT_APP_API_BASE_URL_LOGIN },
  });

  const {
    mutate: changePassword,
    isSuccess: isSuccessChangePassword,
    isLoading: isLoadingChangePassword,
    error: changePasswordError,
  } = useChangePassword({
    axios: {
      baseURL: REACT_APP_API_BASE_URL_LOGIN,
      headers: {
        "x-application-code": REACT_APP_APPLICATION_CODE,
        "x-organization-id": user
          ? (user?.organizations as any[])[0]?.id
          : undefined,
        "x-tenant-code": user
          ? (user?.organizations as any[])[0]?.tenantCode
          : undefined,
      },
    },
  });

  const handleSubmit = (
    handleVerification: (csrfToken: string, timeCount: number) => void
  ) => {
    mutate(
      { data: { email: user?.email as string } },
      {
        onSuccess: (data) => {
          handleVerification(
            data?.data?.data?.csrfToken as string,
            data?.data?.data?.remainSecondExpires as number
          );
        },
      }
    );
  };

  const handleSubmitChangePassword = (
    code: number,
    csrfToken: string,
    password: string,
    setIsModalOpen: Dispatch<SetStateAction<boolean>>,
    reset: UseFormReset<any>
  ) => {
    changePassword(
      { data: { code: +code, csrfToken, password } },
      {
        onSuccess: () => {
          setIsModalOpen(false);
          reset();
        },
      }
    );
  };

  useNotification(
    changePasswordError,
    isSuccessChangePassword,
    UPDATE_SUCCESS_MESSAGE
  );

  return user ? (
    <ResetPasswordForm
      handleSubmitForm={handleSubmit}
      email={user?.email}
      handleSubmitChangePassword={handleSubmitChangePassword}
      isLoadingChangePassword={isLoadingChangePassword}
      errorMessage={
        changePasswordError?.response?.data?.message?.invalid_code as string
      }
    />
  ) : null;
};
